document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('cartcount:update', function(event) {
      const response = event.detail;
      
      if (!response || typeof response.item_count === 'undefined') {
        console.error('Invalid cart update event details');
        return;
      }

      const cartCountElements = document.querySelectorAll('[data-cs-item-count]');
      if (!cartCountElements.length) {
        console.warn('No cart count elements found');
        return;
      }

      cartCountElements.forEach(element => {
        element.textContent = response.item_count;
      });
    });
});
